import React from 'react'
import Separator from '../../../../../components/pdf/Separator'

import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const Terms = ({ serviceOrder }) => {
  return (
    <View>
      <Separator weight={4} />
      <Text>
        Em caso de indisponibilidade de fornecimento dos equipamentos orçados, serão fornecidos outros de qualidade
        idêntica ou superior sem ônus ao cliente.
      </Text>
      <br />
      <Text bold>Observações</Text>
      <br />
      <Text>
        Prezado cliente, com o objetivo de alertar sobre o funcionamento dos equipamentos para proteção da área interna,
        observamos que os sensores que possuem apenas tecnologia infravermelho atuam após a constatação da variação de
        temperatura do ambiente protegido. A intrusão por ferramentas ou apenas mãos e braços podem acontecer sem
        ocasionar a violação do sistema, haja vista que o deslocamento de pequena massa não é suficiente para ser
        percebido pelo sensor.
      </Text>
      <br />
      <Text bold>Garantia</Text>
      <br />
      <Text>Conforme condições estabelecidas pelo fabricante.</Text>
      <br />
    </View>
  )
}

export default Terms
